import { createContext, useContext } from 'react';
import { ApolloError } from '@apollo/client';
import noop from 'utils/noop';
import { TemplateCampaign } from '../common/types';

export interface CampaignQueryContextState {
  errorMessage: string | ApolloError;
  hasError: boolean;
  isLoading: boolean;
  refetch: () => void;
  campaign: TemplateCampaign;
}

export const CampaignQueryContext = createContext<CampaignQueryContextState>({
  errorMessage: '',
  hasError: false,
  isLoading: false,
  refetch: noop,
  campaign: {} as TemplateCampaign,
});

export const useCampaignQueryContext = () => useContext(CampaignQueryContext);
